import React, { Component } from 'react'
import { Navbar } from 'react-bootstrap'
import { Nav } from 'react-bootstrap'
import { Container } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import './pages/Navigation.css'

const navigationBar = {
    backgroundColor: "rgb(40,109,181)",
}
const link = {
    color: "white",
    fontWeight: "bold"
}
export default class Navigation extends Component {
    render() {
        return (


            <Navbar style={navigationBar} expand={"md"}>
                <Navbar.Toggle></Navbar.Toggle>
                <Container>
                    <Nav>
                        <Navbar.Collapse>
                            <Nav.Item>
                                <NavLink className="nav-link " style={link} to={`/our-research`}><h5>Research</h5></NavLink>
                                {/* <NavLink className="nav-link " style={link} to={`${serverConfig}/our-research`}><h5>Research</h5></NavLink> */}
                            </Nav.Item>
                            <Nav.Item>
                                <NavLink className="nav-link " style={link} to={`/our-people`}><h5>People</h5></NavLink>
                                {/* <NavLink className="nav-link " style={link} to={`${serverConfig}/our-people`}><h5>People</h5></NavLink> */}
                            </Nav.Item>
                            <Nav.Item>
                                <NavLink className="nav-link " style={link} to={`/projects`}><h5>Projects</h5></NavLink>
                                {/* <NavLink className="nav-link " style={link} to={`${serverConfig}/projects`}><h5>Projects</h5></NavLink> */}
                            </Nav.Item>
                            <Nav.Item>
                                <NavLink className="nav-link " style={link} to={`/publications`}><h5>Publications</h5></NavLink>
                                {/* <NavLink className="nav-link " style={link} to={`${serverConfig}/publications`}><h5>Publications</h5></NavLink> */}
                            </Nav.Item>
                            <Nav.Item>
                                <NavLink className="nav-link " style={link} to={`/newsandevents`}><h5>News and events</h5></NavLink>
                                {/* <NavLink className="nav-link " style={link} to={`${serverConfig}/newsandevents`}><h5>News and events</h5></NavLink> */}
                            </Nav.Item>
                            <Nav.Item>
                                <NavLink className="nav-link " style={link} to={`/contactus`}><h5>Contact us</h5></NavLink>
                                {/* <NavLink className="nav-link " style={link} to={`${serverConfig}/newsandevents`}><h5>News and events</h5></NavLink> */}
                            </Nav.Item>
                        </Navbar.Collapse>
                    </Nav>
                </Container>

            </Navbar>
        )
    }
}